export default "/images/visibility-lock.svg";